import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  ZeroState,
  Table,
  registerDatePickerLocale,
} from 'ecs-react-components/dist/index.es';
import moment from 'moment';
import { Modal } from 'react-bootstrap';

import { kioskQuestionnairesFiltered } from '../../redux/modules/questionnaires/questionnaires-action-creator';
import { loadKioskQuestionnaires } from '../../redux/modules/questionnaires/questionnaires-middleware';
import { initiatePatientKioskUserLogon } from '../../redux/modules/auth/auth-middleware';
import { messages } from './KioskQuestionnaires.i18n';
import InlineHeader from '../../components/Header/InlineHeader';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';
import { getColumns } from './KioskQuestionnaireTableConfig';

const ALL_FACILITY_OPTION = 'all';

class KioskQuestionnaires extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      modalPatient: null,
      modalTitle: null,
      dueDate: moment().toDate(),
      selectedFacility: props.facility.facilityShortName,
    };
  }

  getKioskQuestionnaires(dueDate, selectedFacility) {
    const {
      dispatch,
    } = this.props;
    dispatch(
      callWithLoadingIndicator('KioskQuestionnaires',
        () => dispatch(loadKioskQuestionnaires(moment(dueDate), selectedFacility)))
    );
  }

  componentDidMount() {
    const {
      dueDate,
      selectedFacility,
      language,
    } = this.state;
    registerDatePickerLocale(language);
    this.getKioskQuestionnaires(dueDate, selectedFacility);
  }

  closeModal = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  clickStart = (patientId) => () => {
    const patient = this.props.patientsWithActiveQuestionnaires.find((x) => x.patientId === patientId);
    const title = <FormattedMessage {...messages.modal.title} />;
    this.setState({ showModal: true, modalPatient: patient, modalTitle: title });
  }

  confirmPatientLogon = (patientId) => {
    this.props.dispatch(initiatePatientKioskUserLogon(patientId));
  }

  getFormattedTitle() {
    const { formatMessage } = this.props.intl;
    const result = formatMessage(messages.page.title,
      {
        facilityName: this.props.facility.facilityName,
        facilityShortName: this.props.facility.facilityShortName,
      });
    return result;
  }

  getFacilityOptions() {
    const { patientsWithActiveQuestionnaires } = this.props;
    let facilities = null;
    if (patientsWithActiveQuestionnaires && patientsWithActiveQuestionnaires.length) {
      facilities = [...new Set(this.props.patientsWithActiveQuestionnaires.map(
        (item) => item.facilityShortName
      ))];
    }

    return facilities && facilities.length ?
      facilities.map((f) => ({ value: f })) :
      null;
  }

  handleDateChange = (dueDate) => {
    this.setState({ dueDate });
    this.getKioskQuestionnaires(dueDate, this.state.selectedFacility);
  }
  handleOnBlur = ({ target: { value } }) => {
    const newRaw = new Date(value);
    if (newRaw instanceof Date && !isNaN(newRaw)) {
      this.handleDateChange(newRaw);
    }
  };
  handleFacilitySelect = (event) => {
    const { dispatch } = this.props;
    const facility = !event.target.value ? ALL_FACILITY_OPTION : event.target.value;
    this.setState({ selectedFacility: facility });
    dispatch(kioskQuestionnairesFiltered(facility));
  }

  renderFacilitySelect(options) {
    const { formatMessage } = this.props.intl;
    return (
      [
        <label htmlFor="facilitySelect" className="form-label">
          <FormattedMessage { ...messages.page.labels.facility } />
        </label>,
        <select
          className="form-select"
          id="facilitySelect"
          onChange={this.handleFacilitySelect}
          value={this.state.selectedFacility}
        >
          <option value="" key="facility_0" >
            { formatMessage(messages.page.labels.all) }
          </option>
          {
            options ?
              options.map((opt, index) =>
                (
                  <option value={opt.value} key={`facility_${index + 1}`}>
                  { opt.value }
                  </option>
                )
              ) :
              null
          }
        </select>,
      ]
    );
  }

  renderContentForInactiveFeature() {
    return (
      <ZeroState
        zeroStateMessage={ <FormattedMessage { ...messages.page.featureInactive } /> }
        stateIconCss="fa-solid fa-list"
      />
    );
  }

  renderContentForActiveFeature() {
    const patientsWithActiveQuestionnaires =
        this.props.patientsWithActiveQuestionnaires && this.props.patientsWithActiveQuestionnaires.length > 0;
    return !patientsWithActiveQuestionnaires ?
      <ZeroState
        zeroStateMessage={<FormattedMessage {...messages.page.noPatientsWithQuestionnaires}/>}
        stateIconCss="fa-solid fa-list"
      />
      :
      <div>
        <Table
          columns={getColumns(this.props.language, this.clickStart)}
          data={this.props.filteredPatients}
          className="align-middle"
        />
      </div>;
  }

  render() {
    const { language, patientsWithActiveQuestionnaires } = this.props;
    const featureInactive = patientsWithActiveQuestionnaires &&
      patientsWithActiveQuestionnaires.length === 1 &&
      patientsWithActiveQuestionnaires[0] === 'feature_inactive';
    const { formatMessage } = this.props.intl;
    const patientFullName = formatMessage(messages.displayNameFormat,
      { 0: this.state.modalPatient ? this.state.modalPatient.firstName : '',
        1: this.state.modalPatient ? this.state.modalPatient.lastName : '' });
    const confirmPatientLogon = () => {
      this.confirmPatientLogon(this.state.modalPatient.patientId);
    };
    const facilityOptions = this.getFacilityOptions();
    return (
      <div id="home-tabs-navs-contents">
        <InlineHeader
          headerTitle={this.getFormattedTitle()}
          titleDescription={messages.page.titleDescription}
        >
          <>
            <div className="col-6">
                  <label htmlFor="dueDatePicker" className="form-label">
                    <FormattedMessage { ...messages.page.labels.dueDate } />
                  </label>
                  <DatePicker id="dueDatePicker"
                    dateFormat="MMM d, yyyy"
                    className="form-control"
                    locale={language}
                    selected={this.state.dueDate}
                    onChange={this.handleDateChange}
                    onBlur={this.handleOnBlur}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="scroll"
                  />
            </div>
            <div className="col-6">
              {this.renderFacilitySelect(facilityOptions)}
            </div>
          </>
        </InlineHeader>
        <LoadingIndicatorContainer loadingKey="KioskQuestionnaires">
          <div>
            {
              featureInactive ?
                this.renderContentForInactiveFeature() :
                this.renderContentForActiveFeature()
            }
          </div>
        </LoadingIndicatorContainer>
        <Modal show={ this.state.showModal }
          onHide={ this.closeModal }
          backdrop="static"
          aria-labelledby="pageTitle"
          data-qa-container="modal"
        >
          <Modal.Header closeButton data-qa-item="modal-header">
            <Modal.Title>
              <div id="pageTitle" className="fs-5" tabIndex="0">
                {this.state.modalTitle}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body data-qa-item="modal-body">
            {
              this.state.modalPatient ?
              <ul className="list-style-type-none">
                <li>
                  <span className="bold">
                    <FormattedMessage {...messages.modal.labels.patientName}></FormattedMessage>
                  </span>
                  &nbsp;
                  { patientFullName }
                </li>
                <li>
                  <span className="bold">
                    <FormattedMessage {...messages.modal.labels.dateOfBirth}></FormattedMessage>
                  </span>
                  &nbsp;
                  {moment(this.state.modalPatient.dateOfBirth).locale(this.props.language).format('L')}
                </li>
                <li>
                  <span className="bold">
                    <FormattedMessage {...messages.modal.labels.mrn}></FormattedMessage>
                  </span>
                  &nbsp;
                  {this.state.modalPatient.mrn}
                </li>
                <li>
                  <span className="bold">
                    <FormattedMessage {...messages.modal.labels.facilityShortName}></FormattedMessage>
                  </span>
                  &nbsp;
                  {this.state.modalPatient.facilityShortName}
                </li>
                <br/>
                <li>
                  <span className="bold">
                    <FormattedMessage {...messages.modal.labels.assignedQuestionnaires}></FormattedMessage>
                  </span>
                  <ul>
                    {
                      this.state.modalPatient.questionnaireTitles.map((title, index) =>
                        (<li key={title + index}>
                          {title}
                         </li>))
                    }
                  </ul>
                </li>
              </ul>
                : null
             }
          </Modal.Body>
          <Modal.Footer data-qa-item="modal-footer">
          <div>
            <button type="button" className="btn btn-primary mr-1"
              onClick={confirmPatientLogon}
            >
              <FormattedMessage {...messages.modal.labels.buttons.yesButton} />
            </button>
            <button type="button" className="btn btn-outline-secondary" onClick={this.closeModal}>
              <FormattedMessage {...messages.modal.labels.buttons.cancelButton} />
            </button>
          </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

KioskQuestionnaires.propTypes = {
  dispatch: PropTypes.func.isRequired,
  intl: PropTypes.object,
  patientsWithActiveQuestionnaires: PropTypes.array,
  filteredPatients: PropTypes.array,
  time: PropTypes.string,
  language: PropTypes.string,
  facility: PropTypes.object,
};

const mapStateToProps = (state) => ({
  patientsWithActiveQuestionnaires: state.questionnaires.patientsWithActiveQuestionnaires,
  filteredPatients: state.questionnaires.filteredPatients,
  language: state.language.languageCode,
  facility: state.facility,
});

export default connect(mapStateToProps)(injectIntl(KioskQuestionnaires));
